import React, { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators';
import { Redirect } from 'react-router'
import Recaptcha from "react-grecaptcha";
import CupoyRouter from "components/commons/router/CupoyRouter";

class LoginView extends Component {
    constructor(props) {
        super(props);

        this.callback = this._callback.bind(this);
        this.expiredCallback = this._expiredCallback.bind(this);
        this.login = this._login.bind(this);
        this.onAdminIDChange = this._onAdminIDChange.bind(this);
        this.onPasswdChange = this._onPasswdChange.bind(this);
        this.onKeyPress = this._onKeyPress.bind(this);

        this.state = {
            adminid: "",
            passwd: "",

            isLogining: false,
            recaptchaResponse: "",

            isAdminIDEmpty: false,
            isPasswdEmpty: false,
            isRecaptcchNoResponse: false,
            isErrorAdminIDorPaddwdMessage: false,
            isAntiPassCodeFailed: false,
            isAdminFreeze: false,
            isSystemError: false
        };
    }


    render() {

        if(this.props.isLogin) {
            return  <Redirect to="/invoice-list/1" />;
        }

        return (
            <div id="login">
                <form
                    id="cupoy-backend-login"
                    className="login-block"
                    action="/admin/AdminMemberAction.do"
                    autoComplete="on"
                >
                    <input name="op" type="hidden" value="101" />
                    <input name="state" type="hidden" value="{{state}}" />
                    <h1 className="title">
                        <img src="./images/logo_small.png" className="logo" alt="捷可印"/>
                        電子發票後台系統
                    </h1>
                    <table>
                        <tbody>
                            <tr>
                                <td className="lebel">管理者帳戶</td>
                                <td className="input">
                                    <input
                                        type="text"
                                        name="adminid"
                                        placeholder="管理者帳戶"
                                        value={this.state.adminid}
                                        onChange={this.onAdminIDChange}
                                        onKeyPress={this.onKeyPress}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="lebel">管理者密碼</td>
                                <td className="input">
                                    <input
                                        type="password"
                                        name="passwd"
                                        placeholder="管理者密碼"
                                        value={this.state.passwd}
                                        onChange={this.onPasswdChange}
                                        onKeyPress={this.onKeyPress}
                                    />
                                </td>
                            </tr>

                            {this.state.isAdminIDEmpty ||
                                this.state.isPasswdEmpty ||
                                this.state.isRecaptcchNoResponse ||
                                this.state.isErrorAdminIDorPaddwdMessage ||
                                this.state.isAdminFreeze ||
                                this.state.isSystemError ? 

                                <tr>
                                    {this.state.isAdminIDEmpty ?
                                        <td
                                            colSpan="2"
                                            className="error-message"
                                        >
                                            請輸入帳戶
                                        </td>
                                        :
                                        null
                                    }

                                    {this.state.isPasswdEmpty ?
                                        <td
                                            colSpan="2"
                                            className="error-message"
                                        >
                                            請輸入密碼
                                        </td>
                                        :
                                        null
                                    }

                                    {this.state.isRecaptcchNoResponse ?
                                        <td
                                            colSpan="2"
                                            className="error-message"
                                        >
                                            請確認你不是機器人
                                        </td>
                                        :
                                        null
                                    }

                                    {this.state.isAntiPassCodeFailed ?
                                        <td
                                            colSpan="2"
                                            className="error-message"
                                        >
                                            驗證錯誤或是驗證已過期
                                        </td>
                                        :
                                        null
                                    }

                                    {this.state.isErrorAdminIDorPaddwdMessage ?
                                        <td
                                            colSpan="2"
                                            className="error-message"
                                        >
                                            輸入的帳戶或是密碼不正確
                                        </td>
                                        :
                                        null
                                    }

                                    {this.state.isAdminFreeze ?
                                        <td
                                            colSpan="2"
                                            className="error-message"
                                        >
                                            該帳戶已經被停權
                                        </td>
                                        :
                                        null
                                    }

                                    {this.state.isSystemError ?
                                        <td
                                            colSpan="2"
                                            className="error-message"
                                        >
                                            發生無法預期的錯誤，請再試一次
                                        </td>
                                        :
                                        null
                                    }
                                  </tr>
                                :
                                null
                            }

                            {this.state.recaptchaResponse ? 
                                <tr>
                                    <td colSpan="2" className="submit">
                                        {!this.state.isLogining ?
                                            <div
                                                className="button blue"
                                                onClick={this.login}
                                            >
                                                {" "}登入
                                            </div>
                                            :
                                            <div className="button blue disable">
                                                {" "}登入中
                                            </div>
                                        }
                                  </td>
                                </tr>
                                :
                                <tr>
                                    <td className="recaptcha" colSpan="2">
                                        <Recaptcha
                                            sitekey="6LfZ0WwUAAAAAIwywSepu9KwcpxFJnenM3nvEdaz"
                                            callback={this.callback}
                                            expiredCallback={
                                                this.expiredCallback
                                            }
                                            locale="zh-TW"
                                            className="g-recaptcha"
                                        />
                                    </td>
                                </tr>
                              }
                        </tbody>
                    </table>
                </form>
            </div>
        );
    }

    _onAdminIDChange(event) {
        this.setState({
            adminid: event.target.value
        });
    }

    _onPasswdChange(event) {
        this.setState({
            passwd: event.target.value
        });
    }

    _onKeyPress(event) {
        if (
            event.charCode === 13 &&
            this.state.adminid &&
            this.state.passwd &&
            this.state.recaptchaResponse
        ) {
            this.login();
        }
    }

    _login() {
        if (!this.state.adminid) {
            this.setState({
                isAdminIDEmpty: true
            });
            return;
        }
        this.setState({
            isAdminIDEmpty: false
        });

        if (!this.state.passwd) {
            this.setState({
                isPasswdEmpty: true
            });
            return;
        }
        this.setState({
            isPasswdEmpty: false
        });

        if (!this.state.recaptchaResponse) {
            this.setState({
                isRecaptcchNoResponse: true
            });
            return;
        }

        this.setState({
            isLogining: true,
            isSystemError: false,
            isErrorAdminIDorPaddwdMessage: false,
            isAdminFreeze: false,
            isRecaptcchNoResponse: false,
            isAntiPassCodeFailed: false,
        });

        this.props.adminActions.login(
            this.state.adminid,
            this.state.passwd,
            this.state.recaptchaResponse
        ).then(
            result => {
                this.props.webActions.cupoyStateGo(CupoyRouter.STATES.INVOICE_LIST, {page: 1});
            },
            error => {
                if (error) {
                    switch (error.code) {
                        case "error.isAccountFreeze":
                            this.setState({
                                isAdminFreeze: true,
                                recaptchaResponse: "",
                                isLogining: false,
                            })
                            break;
                        case "error.formValidator.adminLoginFailed":
                            this.setState({
                                isErrorAdminIDorPaddwdMessage: true,
                                recaptchaResponse: "",
                                isLogining: false,
                            });
                            break;
                        case "error.formValidator.antiPassCodeFailed":
                            this.setState({
                                isAntiPassCodeFailed: true,
                                recaptchaResponse: "",
                                isLogining: false,
                            });
                            break;
                        default:
                            this.setState({
                                isSystemError: true,
                                recaptchaResponse: "",
                                isLogining: false,
                            });
                            break;
                    }
                } else {
                    this.setState({
                        isSystemError: true,
                        isLogining: false,
                        recaptchaResponse: "",
                    });
                }
            }
        );
    }

    _callback(response) {
        this.setState({
            recaptchaResponse: response
        });
    }

    _expiredCallback() {
        console.log("expiredCallback");
    }
}

const mapStateToProps = function(state) {
    return {
        isLogin: state.admin.isLogin
    };
};

const mapActionToProps = function(dispatch) {
    return {
        webActions: bindActionCreators(actionCreators.webActionCreators, dispatch),
        adminActions: bindActionCreators(actionCreators.adminActionCreators, dispatch)
    };
};

export default connect(mapStateToProps, mapActionToProps, null, {
    withRef: true
})(LoginView);



// WEBPACK FOOTER //
// ./src/components/LoginView.js